import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'
import store from '@/store'

const request = axios.create({
  baseURL: '/api',
  timeout: 30000
})

// 请求拦截器：自动携带 Token
request.interceptors.request.use(
  config => {
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    // 生成请求 ID 用于跟踪
    const requestId = Math.random().toString(36).substr(2, 9)
    config._requestId = requestId
    config._requestStartTime = Date.now()

    // 记录请求
    console.debug(`API 请求: ${config.method?.toUpperCase()} ${config.url}`, {
      requestId,
      params: config.params,
      data: config.data
    })

    return config
  },
  error => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器：统一错误处理
request.interceptors.response.use(
  response => {
    const requestId = response.config._requestId
    const duration = response.config._requestStartTime ? Date.now() - response.config._requestStartTime : null
    const res = response.data

    if (res.code === 200 || res.code === 0) {
      // 成功响应
      console.debug(`API 响应成功: ${response.config.method?.toUpperCase()} ${response.config.url}`, {
        requestId,
        duration,
        code: res.code
      })
      return res.data !== undefined ? res.data : res
    }

    // 业务错误
    console.warn(`API 业务错误: ${response.config.method?.toUpperCase()} ${response.config.url}`, {
      requestId,
      duration,
      code: res.code,
      message: res.message
    })
    Toast.fail(res.message || '请求失败')
    return Promise.reject(new Error(res.message))
  },
  async error => {
    const requestId = error.config?._requestId
    const duration = error.config?._requestStartTime ? Date.now() - error.config._requestStartTime : null
    const status = error.response?.status
    const url = error.config?.url

    // 记录错误
    console.error(`API 请求失败: ${error.config?.method?.toUpperCase()} ${url}`, {
      requestId,
      duration,
      status,
      message: error.message,
      response: error.response?.data
    })

    if (status === 401) {
      // 尝试刷新 token
      const refreshToken = store.getters.refreshToken
      if (refreshToken && !error.config._retry) {
        error.config._retry = true
        try {
          await store.dispatch('refreshToken')
          error.config.headers['Authorization'] = 'Bearer ' + store.getters.token
          return request(error.config)
        } catch (e) {
          store.dispatch('logout')
          // 避免重复导航到登录页
          if (router.currentRoute.path !== '/login') {
            router.push('/login').catch(err => {
              // 忽略重复导航错误
              if (err.name !== 'NavigationDuplicated') {
                throw err
              }
            })
          }
          return Promise.reject(e)
        }
      } else {
        store.dispatch('logout')
        // 避免重复导航到登录页
        if (router.currentRoute.path !== '/login') {
          router.push('/login').catch(err => {
            // 忽略重复导航错误
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
        }
      }
    } else if (status === 403) {
      Toast.fail('无权限访问')
    } else if (status === 500) {
      Toast.fail('服务器内部错误')
    } else {
      Toast.fail(error.message || '网络请求失败')
    }
    return Promise.reject(error)
  }
)

export default request
